import axios from 'axios';
import {
  TransferBondCalculationRequest,
  TransferBondCalculationResponse,
  ParametersResponse,
} from '../types/calculator.types';

// Use runtime config if available, otherwise fall back to env var
declare global {
  interface Window {
    APP_CONFIG?: {
      API_URL: string;
    };
  }
}

const API_BASE_URL = window.APP_CONFIG?.API_URL || process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Configure axios defaults
axios.defaults.headers.common['Content-Type'] = 'application/json';

export const calculatorApi = {
  /**
   * Calculate transfer and bond costs
   */
  calculateTransferBond: async (
    request: TransferBondCalculationRequest
  ): Promise<TransferBondCalculationResponse> => {
    const response = await axios.post<TransferBondCalculationResponse>(
      `${API_BASE_URL}/transfer-bond-calc`,
      request
    );
    return response.data;
  },

  /**
   * Get system parameters (VAT rate, etc.)
   */
  getParameters: async (): Promise<ParametersResponse> => {
    const response = await axios.get<ParametersResponse>(
      `${API_BASE_URL}/parameters`
    );
    return response.data;
  },

  /**
   * Download PDF calculation
   */
  downloadPdf: (data: {
    transfer: number;
    bond: number;
    name: string;
    email: string;
    contactNumber?: string;
    buyingAProperty?: string;
    offerMade?: string;
  }) => {
    const params = new URLSearchParams();
    params.append('transfer', data.transfer.toString());
    params.append('bond', data.bond.toString());
    params.append('name', data.name);
    params.append('email', data.email);
    if (data.contactNumber) params.append('contact_number', data.contactNumber);
    if (data.buyingAProperty) params.append('buying_a_property', data.buyingAProperty);
    if (data.offerMade) params.append('offer_made', data.offerMade);

    window.location.href = `${API_BASE_URL}/transfer-bond-calc-download?${params.toString()}`;
  },

  /**
   * Email PDF calculation
   */
  emailPdf: async (data: {
    transfer: number;
    bond: number;
    name: string;
    email: string;
    contactNumber?: string;
    buyingAProperty?: string;
    offerMade?: string;
  }): Promise<TransferBondCalculationResponse> => {
    const params = new URLSearchParams();
    params.append('transfer', data.transfer.toString());
    params.append('bond', data.bond.toString());
    params.append('name', data.name);
    params.append('email', data.email);
    if (data.contactNumber) params.append('contact_number', data.contactNumber);
    if (data.buyingAProperty) params.append('buying_a_property', data.buyingAProperty);
    if (data.offerMade) params.append('offer_made', data.offerMade);

    const response = await axios.get<TransferBondCalculationResponse>(
      `${API_BASE_URL}/transfer-bond-calc-email?${params.toString()}`
    );
    return response.data;
  },
};
